module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAWBAMAAAD6A0vjAAAAGFBMVEVXs3BXs3BXs3BXs3BXs3BXs3BXs3BXs3C7ELBBAAAAB3RSTlO79B6/uvMfGYQZbwAAAB9JREFUCNdjUAlRYGAvN2AQLy9gKKcMg8wAm6UgkAAAiZQaYThFypwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_green.png
// module id = V8Pl
// module chunks = 0